var e4       = e4 || {},
    isabella = isabella || {};
( function () {
    'use strict';

    isabella.bootstrapInitialize = {
        // WIP - TEMP. TO-DO, JD:General builded - Not productlist only.
        init: function () {
            jQuery( '[data-toggle="popover"]' ).popover();
            jQuery( '.js-e-productlist' ).on( 'builded.e4.productlist', function () {
                jQuery( '[data-toggle="popover"]' ).popover();
            } );
        }
    };
    isabella.scrollToProductlist = {
        init: function () {
            jQuery( '.btn-scroll-to-productlist' ).on( 'click', function () {
                e4.scrollToAnchor.animate( e4.scrollToAnchor.getTarget( '.js-e-productlist' ) - 100 );
            } );
        }
    };
    isabella.rwdImageMaps        = function () {
        var useMaps = jQuery( 'img[usemap]' );
        if ( useMaps.length > 0 ) {
            jQuery.when.apply( jQuery, [
                e4.util.require.js( e4.settings.require.rwdImageMaps )
            ] ).then( function () {
                useMaps.each( function ( index, domImg ) {
                    jQuery( domImg ).rwdImageMaps();
                } );
            } );
        }
    };
    isabella.activeCampaign      = {
        init: function () {
            var jActiveCampaignForms = jQuery( '.js-isabella-activecampaign' );
            if ( jActiveCampaignForms.length > 0 ) {
                jActiveCampaignForms.find( '._button-wrapper ._submit' ).removeClass( '_submit' ).addClass( 'btn btn-primary' );
            }
        },
        submit: function(){
            var jForm = jQuery('.js-isabella-embedded-active-campaign-form-container').find('form');

            if(jForm){
                jQuery.ajax({
                    url: jForm.attr('action'),
                    crossDomain: true,
                    dataType: 'jsonp',
                    method: jForm.attr('method'),
                    data: jForm.serialize()
                });
            }
        }
    };
    isabella.pdf                 = {
        load: function () {
            if ( jQuery( '.js-isabella-sign-builder' ).length === 1 ) {
                jQuery.when.apply( jQuery, [
                    e4.util.require.js( e4.settings.require.pdfUtils ),
                    e4.util.require.js( e4.settings.require.signBuilder )
                ] ).then( function () {
                    isabella.signBuilder.init();
                } );
            }
            if ( jQuery( '.js-isabella-product-details-pdf' ).length === 1 ) {
                jQuery.when.apply( jQuery, [
                    e4.util.require.js( e4.settings.require.pdfUtils ),
                    e4.util.require.js( e4.settings.require.productDetailsPdf )
                ] ).then( function () {
                    isabella.productDetailsPdf.init();
                } ).catch( function ( err ) {
                    console.log( err );
                } );
            }
            if ( jQuery( '.js-isabella-villa-and-camplet-pdf' ).length === 1 ) {
                jQuery.when.apply( jQuery, [
                    e4.util.require.js( e4.settings.require.pdfUtils ),
                    e4.util.require.js( e4.settings.require.villaAndCampletPdf )
                ] ).then( function () {
                    isabella.villaAndCampletPdf.init();
                } );
            }
        }
    };
    isabella.masterlogin         = function () {
        /*
         if ( jQuery( '.js-master-login-form' ).length ) {
         console.log( 'enabled master login #4' );

         e4.util.require.js( e4.settings.require.jQueryValidate, function () {

         jQuery.validator.addMethod( 'pwcheck', function ( value ) {
         return /^[A-Za-z0-9\d=!\-@._*]*$/.test( value ) // consists of only these
         && /[a-z]/.test( value ) // has a lowercase letter
         && /\d/.test( value ) // has a digit
         } );


         jQuery( '.js-master-login-form' ).validate( {
         submitHandler: function ( form ) {
         var params = jQuery( form ).serialize();
         console.log( 'Form is submitted : ', params );
         form.submit();
         },
         } );
         jQuery( 'input[name="TextBox_Password"]' ).each( function () {
         jQuery( this ).rules( 'add', {
         required: true,
         pwcheck: true,
         minlength: 8,
         messages: {
         pwcheck: jQuery( this ).data( 'error' ),
         minlength: 'min. 8 characters'
         }
         } );
         } );

         } )
         }

         */
    };
    isabella.measureSearch       = {
        showProductlist: false,
        init: function () {
            if ( jQuery( '.js-isabella-a-measure' ).length === 1 ) {
                e4.util.require.js( e4.settings.require.handlebars, function () {
                    e4.handlebars.registerHelpers( 'compare' );
                    isabella.measureSearch.handlebars.registerHelpers();
                    e4.handlebars.registerTemplates( '#js-e-handlebars-tmpl-a-measure-results #js-e-handlebars-tmpl-productlist-products' );
                    isabella.measureSearch.bindEvents();
                    isabella.measureSearch.hasQuery();
                } );
            }
        },
        handlebars: {
            registerHelpers: function () {
                Handlebars.registerHelper( 'count', function ( array ) {
                    return array.length;
                } );
            }
        },
        bindEvents: function () {
            jQuery( '.js-isabella-a-measure-form' ).on( 'submit', function ( event ) {
                event.preventDefault();
                var postObj = jQuery( event.target ).serialize();
                isabella.measureSearch.search( postObj );
            } );
            jQuery( '.js-isabella-a-measure-results-container' ).on( 'click', '.js-a-measure-paging', function ( event ) {
                event.preventDefault();
                var strPagingParams = event.target.href;
                isabella.measureSearch.paging( strPagingParams );
            } ).on( 'click', '.js-a-measure-productlist-link', function ( event ) {
                event.preventDefault();
                isabella.measureSearch.setSelected( event.target );
                isabella.measureSearch.productlist.post( event.target.dataset.measure );
            } );
        },
        hasQuery: function () {
            if ( location.search.length > 1 ) {
                isabella.measureSearch.search( location.search.substring( 1 ) );
            }
        },
        setSelected: function ( domElm ) {
            jQuery( '.js-a-measure-productlist-link' ).closest( '.js-a-measure-result-row' ).removeClass( 'selected' );
            jQuery( domElm ).closest( '.js-a-measure-result-row' ).addClass( 'selected' );
        },
        extractParamsFormUrl: function ( strUrl ) {
            var arrUrlParams = strUrl.split( '&' );
            arrUrlParams.shift();
            return arrUrlParams.join( '&' );
        },
        updateHistory: function ( url ) {
            history.pushState( url, null, location.pathname + '?' + url );
        },
        clearResults: function () {
            jQuery( '.js-isabella-a-measure-results' ).html( '' );
        },
        search: function ( postObj ) {
            jQuery.ajax( {
                url: e4.settings.ameasure.url,
                method: 'POST',
                beforeSend: function () {
                    isabella.measureSearch.clearResults();
                    isabella.measureSearch.productlist.hide();
                    jQuery( '.js-isabella-a-measure-loader' ).addClass( 'is-loading' );
                },
                data: postObj
            } ).done( function ( data ) {
                isabella.measureSearch.updateHistory( postObj );
                isabella.measureSearch.build( data );
                jQuery( '.js-isabella-a-measure-loader' ).removeClass( 'is-loading' );
            } );
        },
        paging: function ( strPagingParams ) {
            var strPostUrl = isabella.measureSearch.extractParamsFormUrl( strPagingParams );
            isabella.measureSearch.search( strPostUrl );
        },
        build: function ( data ) {
            var productlistUrl  = jQuery( '.js-a-measure-productlist-url' ).val();
            data.productlistUrl = productlistUrl;
            jQuery( '.js-isabella-a-measure-results' ).html( e4.handlebars.tmpl.aMeasureResults( data ) );
        },
        productlist: {
            post: function ( aMeasure ) {
                var strUrlParam           = jQuery( '.js-e-productlist-form' ).serialize(),
                    disableProductDetails = jQuery( '.js-a-measure-product-details' ).val();
                strUrlParam += '&' + aMeasure;
                jQuery.ajax( {
                    method: 'GET',
                    dataType: 'json',
                    url: e4.settings.ecom.filters.url,
                    beforeSend: function () {
                        jQuery( '.js-isabella-a-measure-loader, .js-e-products-loading-overlay' ).addClass( 'is-loading' );
                    },
                    cache: false,
                    data: strUrlParam
                } ).done( function ( data ) {
                    jQuery( '.js-isabella-a-measure-loader, .js-e-products-loading-overlay' ).removeClass( 'is-loading' );
                    data.disableProductDetails = disableProductDetails === 'True';
                    jQuery( '#js-e-productlist-products' ).html( e4.handlebars.tmpl.productlistProducts( data ) );
                    isabella.measureSearch.productlist.show();
                } );
            },
            show: function () {
                jQuery( '.js-a-measure-product-results' ).removeClass( 'd-none' );
                jQuery( '#js-isabella-a-measure-results-table' ).collapse( 'hide' );
            },
            hide: function () {
                jQuery( '.js-a-measure-product-results' ).addClass( 'd-none' );
                jQuery( '#js-e-productlist-products' ).html( '' );
            }
        }
    };
    isabella.ecom                = {
        init: function () {
            isabella.ecom.bindEvents();
            isabella.ecom.event = e4.util.registerEvents( 'pdfReady', 'ecom' );
            isabella.ecom.checkout.dealerSearch.init();
            isabella.ecom.recommendedProducts.init();
        },
        utils: {
            roundUp: function ( intQuantity, intColli ) {
                return Math.ceil( ( intQuantity + 1 ) / intColli ) * intColli;
            }
        },
        bindEvents: function () {
            jQuery( document ).on( 'input', '.js-isabella-colli-quanitity', e4.util.debounce( function ( event ) {
                isabella.ecom.colli.validate( event.target );
            }, e4.settings.ecom.cart.debounceDelay - 50 ) ).find( '.js-isabella-colli-quanitity' ).each( function ( index, element ) {
                jQuery( element ).trigger( 'input' );
            } );
            jQuery( document ).on( 'focus', '.js-isabella-quanitity, .js-pdf-quantity', function ( event ) {
                jQuery( event.target ).select();
            } ).on( 'keydown', '.js-isabella-quanitity', function ( event ) {
                var step  = 1,
                    value = parseInt( event.target.value );
                if ( isNaN( value ) === true ) {
                    return;
                }
                if ( event.target.dataset.step && parseInt( event.target.dataset.step ) > 0 ) {
                    step = parseInt( event.target.dataset.step );
                }
                if ( event.which === 38 ) {
                    value += step;
                }
                else if ( event.which === 40 ) {
                    value -= step;
                }
                event.target.value = value;
            } );
            jQuery( '.js-isabella-product-form-addtocart' ).on( 'input', '.js-isabella-quanitity', function ( event ) {
                if ( jQuery( event.target ).is( '.js-isabella-colli-quanitity' ) === false ) {
                    isabella.ecom.relatedProducts.calculate();
                }
            } );
            jQuery( '.js-isabella-product-details-pdf' ).on( 'pdfReady.e4.ecom', function () {
                isabella.ecom.relatedProducts.calculate();
            } );
            jQuery( document ).on( 'input', '.js-pdf-quantity', function () {
                isabella.ecom.relatedProducts.calculate();
            } );
            isabella.ecom.relatedProducts.calculate();
        },
        colli: {
            validate: function ( domElm ) {
                var intColli    = parseInt( jQuery( domElm ).data( 'colli' ) ),
                    intQuantity = parseInt( jQuery( domElm ).val() );
                if ( intColli > 1 ) {
                    if ( isNaN( intColli ) === false && isNaN( intQuantity ) === false && intColli > 0 && intQuantity > 0 ) {
                        if ( intQuantity % intColli !== 0 ) {
                            jQuery( domElm ).val( isabella.ecom.utils.roundUp( intQuantity, intColli ) );
                        }
                    }
                }
                isabella.ecom.relatedProducts.calculate();
            }
        },
        recommendedProducts: {
            init: function () {
                var jRecommendedProducts = jQuery( '.js-e-recommended-products' );
                if ( jRecommendedProducts.length > 0 ) {
                    if ( jQuery( '.js-e-product' ).length ) {
                        e4.util.require.js( e4.settings.require.handlebars, function () {
                            e4.handlebars.registerHelpers( 'compare' );
                            e4.handlebars.registerTemplates( '#js-e-handlebars-tmpl-recommended-products' );
                            jRecommendedProducts.each( function ( index, domElm ) {
                                isabella.ecom.recommendedProducts.getByRecommendationType( domElm.dataset.recommendation, domElm.dataset.recommendation, false );
                            } )
                        } );
                    }
                    else {
                        jQuery( '.js-e-recommended-products-container' ).remove();
                    }
                }
            },
            getByRecommendationType: function ( strRecommendation, strTarget, isFallback ) {
                var objPostData    = {},
                    objProductData = jQuery( '.js-e-product' ).data();
                switch ( strRecommendation ) {
                    case 'boughtWith':
                        objPostData = {
                            PID: objProductData.productId,
                            PageSize: 4
                        };
                        break;
                    case 'bestSellers':
                        objPostData = {
                            PageSize: 4
                        };
                        break;
                    case 'bestSellersByGroup':
                        objPostData = {
                            GroupIds: objProductData.groupId,
                            PageSize: 4
                        };
                        break;
                }
                isabella.ecom.recommendedProducts.fetchAndBuild( objPostData, strTarget, isFallback );
            },
            fetchAndBuild: function ( objPostData, strTarget, isFallback ) {
                jQuery.ajax( {
                    url: e4.settings.ecom.recommended.url,
                    data: objPostData
                } ).done( function ( json ) {
                    var jRecommendation = jQuery( '.js-e-recommended-products[data-recommendation="' + strTarget + '"]' ),
                        jContainer      = jRecommendation.find( '.js-e-recommended-products-container' );
                    if ( json.products.length > 0 ) {
                        jContainer.html( e4.handlebars.tmpl.recommendedProducts( {
                            products: json.products,
                            heading: isFallback ? jRecommendation.data( 'fallbackHeading' ) : jRecommendation.data( 'heading' )
                        } ) );
                    } else {
                        jQuery( '.js-e-recommended-products-container' ).remove();
                    }
                    /*
                    else {
                        if ( strTarget !== 'bestSellers' ) {
                            isabella.ecom.recommendedProducts.getByRecommendationType( 'bestSellersByGroup', strTarget, true );
                        }
                        else {
                            jQuery( '.js-e-recommended-products-container' ).remove();
                        }
                    }
                    
                     */
                } );
            }
        },
        relatedProducts: {
            intTotalPDFPrice: 0,
            getCalculateTotalForPdf: function () {
                var returnValue = 0;
                jQuery( document ).find( '.js-pdf-quantity' ).each( function ( index, element ) {
                    var jQuantity = parseInt( jQuery( element ).val() ),
                        jPrice    = jQuery( element ).data( 'price' );
                    if ( jQuantity === '' ) {
                        jQuantity = 0;
                    }
                    returnValue += ( e4.util.formatStringToJavascriptNumber( jPrice ) * parseInt( jQuantity ) );
                    isabella.ecom.relatedProducts.updatePdfModel( element, parseInt( jQuantity ), jPrice );
                } );
                return returnValue;
            },
            calculate: function () {
                var intTotalPrice = 0;
                jQuery( document ).find( '.js-isabella-quanitity' ).each( function ( index, element ) {
                    var jQuantity = parseInt( jQuery( element ).val() ),
                        strKey    = element.dataset.key,
                        jPrice    = jQuery( element ).data( 'price' );
                    if ( jQuantity === '' ) {
                        jQuantity = 0;
                    }
                    intTotalPrice += ( e4.util.formatStringToJavascriptNumber( jPrice ) * parseInt( jQuantity ) );
                    if ( jQuery( element ).is( '.js-isabella-related-product-quantity' ) === true ) {
                        isabella.ecom.relatedProducts.updateChildProductsQuantity( element, parseInt( jQuantity ) );
                        isabella.ecom.relatedProducts.updatePdfModel( element, parseInt( jQuantity ), jPrice );
                    }
                    if ( jQuery( element ).data( 'key' ) === 'Accessories' ) {
                        var container = jQuery( element ).closest( '.collapse' ),
                            acceptRow = jQuery( document ).find( '.js-isabella-quanitity[data-key="AccessoriesWithFrames"]' ).closest( '.collapse' ).find( '.js-isabella-accept-no-frame-row' ),
                            total     = 0;
                        container.find( '.js-isabella-quanitity' ).each( function ( index, input ) {
                            total += parseInt( input.value );
                        } );
                        if ( total > 0 ) {
                            jQuery( document ).find( '.js-isabella-quanitity[data-key="AccessoriesWithFrames"]' ).closest( '.collapse' ).collapse( 'show' );
                            acceptRow.find( '.js-isabella-accept-no-frame-input' ).addClass( 'required' ).removeClass( 'js-has-added-quantity js-ignore-in-validation' );
                            acceptRow.show();
                        }
                        else {
                            acceptRow.find( '.js-isabella-accept-no-frame-input' ).removeClass( 'required' ).addClass( 'js-has-added-quantity js-ignore-in-validation' );
                            acceptRow.hide();
                        }
                    }
                    if ( strKey === 'Frames' || strKey === 'AccessoriesWithFrames' ) {
                        isabella.ecom.relatedProducts.showHideAcceptRow( element, element.dataset.key );
                    }
                } );
                isabella.ecom.relatedProducts.updateTotal( intTotalPrice );
            },
            showHideAcceptRow: function ( domElm, key ) {
                var container = jQuery( domElm ).closest( '.collapse' ),
                    acceptRow = jQuery( document ).find( '.js-isabella-quanitity[data-key="' + key + '"]' ).closest( '.collapse' ).find( '.js-isabella-accept-no-frame-row' ),
                    total     = 0,
                    ref       = key === 'AccessoriesWithFrames' ? 'Accessories' : '',
                    refTotal  = 0;
                if ( ref !== '' ) {
                    jQuery( document ).find( '.js-isabella-quanitity[data-key="' + ref + '"]' ).each( function ( index, input ) {
                        refTotal += parseInt( input.value );
                    } );
                }
                container.find( '.js-isabella-quanitity' ).each( function ( index, input ) {
                    total += parseInt( input.value );
                } );
                if ( acceptRow.length ) {
                    if ( ( ref === 'Accessories' && ( refTotal === 0 && jQuery( '.js-isabella-quanitity[data-key="Frames"]' ).length > 0 ) ) ) {
                        acceptRow.find( '.js-isabella-accept-no-frame-input' ).removeClass( 'required' ).addClass( 'js-ignore-in-validation' )
                        acceptRow.hide();
                    }
                    else if ( total > 0 ) {
                        acceptRow.find( '.js-isabella-accept-no-frame-input' ).removeClass( 'required' ).addClass( 'js-ignore-in-validation' )
                        acceptRow.hide();
                    }
                    else {
                        acceptRow.find( '.js-isabella-accept-no-frame-input' ).addClass( 'required' ).removeClass( 'js-ignore-in-validation' );
                        acceptRow.show();
                    }
                }
            },
            updateChildProductsQuantity: function ( domElm, intQuantity ) {
                jQuery( domElm ).closest( '.js-isabella-product-form-row' ).find( '.js-isabella-related-product-child-quantity-input' ).each( function ( index, element ) {
                    jQuery( element ).val( intQuantity );
                } );
            },
            updatePdfModel: function ( domElm, intQuantity, strPrice ) {
                var relatedProductId   = jQuery( domElm ).closest( '.js-isabella-product-form-row' ).find( '.js-related-product-id' ).val(),
                    relatedProductText = jQuery( domElm ).closest( '.js-isabella-product-form-row' ).find( '.js-related-product-name' ).val();
                if ( isabella.productDetailsPdf !== undefined ) {
                    if ( intQuantity > 0 && relatedProductId !== undefined ) {
                        isabella.productDetailsPdf.model.addons[ relatedProductId ] = {
                            id: relatedProductId,
                            text: relatedProductText,
                            price: e4.util.formatJavascriptNumberToLocaleString( e4.util.formatStringToJavascriptNumber( strPrice ) * intQuantity )
                        };
                    }
                    else {
                        delete isabella.productDetailsPdf.model.addons[ relatedProductId ];
                    }
                }
            },
            updateTotal: function ( intTotalPrice ) {
                jQuery( '.js-isabella-calculated-price' ).find( '.e-price-price' ).html( e4.util.formatJavascriptNumberToLocaleString( intTotalPrice ) );
                if ( jQuery( '.js-isabella-product-form-addtocart' ).length ) {
                    if ( isabella.productDetailsPdf !== undefined ) {
                        isabella.ecom.relatedProducts.updateTotalPdf( intTotalPrice );
                    }
                }
            },
            updateTotalPdf: function ( intTotalPrice ) {
                var pdtTotal = isabella.ecom.relatedProducts.getCalculateTotalForPdf();
                isabella.productDetailsPdf.model.set( 'totalPrice', e4.util.formatJavascriptNumberToLocaleString( ( intTotalPrice + pdtTotal ) ) );
            },
            checkAccept: function () {
                var framesCount       = 0,
                    isAcceptChecked   = jQuery( '.js-isabella-accept-no-frame-input' ).is( ':checked' ),
                    framesSelector    = jQuery( '.js-isabella-related-product-quantity[data-key="Frames"]' ),
                    accFramesSelector = jQuery( '.js-isabella-related-product-quantity[data-key="AccessoriesWithFrames"]' );
                if ( framesSelector.length > 0 ) {
                    framesSelector.each( function ( index, input ) {
                        framesCount += parseInt( input.value );
                    } );
                }
                if ( accFramesSelector.length > 0 ) {
                    accFramesSelector.each( function ( index, input ) {
                        framesCount += parseInt( input.value );
                    } );
                }
                if ( framesCount === 0 && isAcceptChecked === false ) {
                    return false;
                }
                return true;
            },
            toggleAccept: function ( intRelatedCount ) {
                var jAcceptRow = jQuery( '.js-isabella-accept-no-frame-row' );
                if ( intRelatedCount > 0 ) {
                    jAcceptRow.hide();
                }
                else {
                    jAcceptRow.show();
                }
            },
            showFramesAccept: function () {
                jQuery( '#isabella-product-form-collapse-Frames' ).collapse( 'show' );
            }
        },
        checkout: {
            dealerSearch: {
                init: function () {
                    if ( jQuery( '.js-e-cart-b2c' ).length === 1 ) {
                        jQuery( '.js-e-cart' ).on( 'loaded.e4.cart', function ( event, data ) {
                            e4.util.require.js( e4.settings.require.handlebars, function () {
                                e4.handlebars.registerHelpers( 'compare' );
                                e4.handlebars.registerTemplates( '#js-e-handlebars-tmpl-cart-b2c-dealer' );
                                isabella.ecom.checkout.dealerSearch.bindEvents();
                                isabella.ecom.checkout.dealerSearch.build( data );
                                if ( e4.util.hash.get( 'dealerselect' ) === 'true' ) {
                                    jQuery( document ).on( e4.dealersearch.event.loaded, function () {
                                        jQuery( '.js-isabella-cart-dealersearch-modal' ).modal( 'show' );
                                    } );
                                }
                            } );
                        } );
                    }
                },
                getData: function ( strTypes ) {
                    var jDealersearch = jQuery( '.js-e-dealersearch' );
                    return jQuery.ajax( {
                        url: e4.settings.dealersearch.url,
                        data: {
                            groupId: jDealersearch.data( 'groupId' ),
                            countryCode: jDealersearch.data( 'countryCode' ),
                            type: strTypes,
                            context: 'cart'
                        },
                        dataType: 'json',
                        cache: false
                    } ).done( function ( jsonData ) {
                        e4.dealersearch.data = jsonData;
                    } );
                },
                setType: function () {
                    var typeArr = [];
                    jQuery( '.js-e-orderline' ).each( function ( index, element ) {
                        if ( jQuery( element ).data( 'isIsabellaProduct' ) === true ) {
                            typeArr.push( 'Isabella' );
                            typeArr.push( 'AutoCamper' );
                        }
                        if ( jQuery( element ).data( 'isCampletProduct' ) === true ) {
                            typeArr.push( 'Camplet' );
                        }
                        if ( jQuery( element ).data( 'isVillaProduct' ) === true ) {
                            typeArr.push( 'Villa' );
                        }
                    } );
                    jQuery.when( isabella.ecom.checkout.dealerSearch.getData( typeArr.join( ',' ) ) ).then( function () {
                        e4.dealersearch.map.setBoundsFromCountry();
                        // e4.dealersearch.form.clearInput();
                        e4.dealersearch.markers.removeFromClusterer();
                        e4.dealersearch.markers.init();
                    } );
                },
                bindEvents: function () {
                    jQuery( '.js-isabella-cart-dealersearch-modal' ).on( 'show.bs.modal', function () {
                        isabella.ecom.checkout.dealerSearch.setType();
                    } ).on( 'hide.bs.modal', function () {
                        e4.util.hash.remove( 'dealerselect' );
                    } ).on( 'click', '.js-isabella-cart-dealersearch-select', function ( event ) {
                        event.preventDefault();
                        isabella.ecom.checkout.dealerSearch.select( jQuery( this ).data( 'id' ) );
                    } );
                },
                select: function ( dealerId ) {
                    var dealer = e4.dealersearch.data.users.filter( function ( obj ) {
                        return parseInt( obj.id ) === dealerId;
                    } )[ 0 ];
                    if ( dealer ) {
                        /*var dealerObj = {
                         EcomOrderCustomerDealer: 'test',//dealer.id,
                         EcomOrderDeliveryName: 'test',//dealer.name,
                         EcomOrderDeliveryAddress: 'test',//dealer.address,
                         EcomOrderDeliveryAddress2: 'test',//dealer.address2,
                         EcomOrderDeliveryZip: '1234',//dealer.zip,
                         EcomOrderDeliveryCity: 'test',//dealer.city,
                         EcomOrderDeliveryCountry: dealer.country,
                         EcomOrderDeliveryCountryCode: dealer.countryCode,
                         EcomOrderDeliveryPhone: dealer.phone,
                         EcomOrderDeliveryMail: 'lhnxyz@co3.dk',//dealer.mail,
                         Company: dealer.company
                         }*/
                        var dealerObj = {
                            EcomOrderCustomerDealer: dealer.id,
                            EcomOrderDeliveryName: dealer.name,
                            EcomOrderDeliveryAddress: dealer.address,
                            EcomOrderDeliveryAddress2: dealer.address2,
                            EcomOrderDeliveryZip: dealer.zip,
                            EcomOrderDeliveryCity: dealer.city,
                            EcomOrderDeliveryCountry: dealer.country,
                            EcomOrderDeliveryCountryCode: dealer.countryCode,
                            EcomOrderDeliveryPhone: dealer.phone,
                            EcomOrderDeliveryMail: dealer.mail,
                            Company: dealer.company
                        };
                        isabella.ecom.checkout.dealerSearch.set( dealerObj );
                    }
                },
                set: function ( dealerObj ) {
                    e4.cart.ajax( {
                        data: dealerObj
                    }, function ( data ) {
                        jQuery( '.js-isabella-cart-dealersearch-modal' ).modal( 'hide' );
                        isabella.ecom.checkout.dealerSearch.build( data );
                    } );
                },
                build: function ( data ) {
                    jQuery( '.js-e-cart-b2c-dealer-container' ).html( e4.handlebars.tmpl.cartB2cDealer( data.cart.dealer ) );
                }
            }
        }
    };
}() );
